import __config from '@/config';
import { getType } from '@/utils/base';

const { isLocal, apiEnv, apiPrefixGroup } = __config;

// 基础接口前缀
let hnBase = '/cgi_hn_base';
if (!isLocal) hnBase = apiPrefixGroup.hn_base[apiEnv];

// 基础接口前缀
const base = isLocal ? '/cgi_base' : window.location.origin;
const baseApi = `${base}/wisdomcloud/api`;

// 基础接口前缀 - 固定测试环境
let fixBaseTest = '/cgi_fixBaseTest';
if (!isLocal) fixBaseTest = apiPrefixGroup.fixBaseTest[apiEnv];
const fixBaseTestApi = `${fixBaseTest}/wisdomcloud/api`;

// 付费险
let ffx = '/cgi_ffx';
if (!isLocal) ffx = apiPrefixGroup.ffx[apiEnv];
const ffxApi = `${ffx}/ffx/api`;

// 用户中台
let userAccount = '/cgi_user_account';
if (!isLocal) userAccount = apiPrefixGroup.user_account[apiEnv];
const userAccountApi = `${userAccount}/ua/api`;

// rgyb fs
let attend = '/cgi_attend';
if (!isLocal) attend = apiPrefixGroup.attend[apiEnv];
const attendApi = `${attend}`;

// 用户中台
let ai = '/cgi_ai';
if (!isLocal) ai = apiPrefixGroup.ai[apiEnv];
const aiApi = `${ai}/large_scale_model/api`;

let fixAiTest = '/cgi_fixAiTest';
if (!isLocal) fixAiTest = apiPrefixGroup.fixAiTest[apiEnv];
const fixAiTestApi = `${fixAiTest}/large_scale_model/api`;

// 电销
let telemarketing = '/cgi_telemarketing';
if (!isLocal) telemarketing = apiPrefixGroup.telemarketing[apiEnv];
const telemarketingApi = `${telemarketing}/api`;

// 前缀域名
export const apiPrefix = {
  hnBase,
  base,
  baseApi,
  fixBaseTestApi,
  ffx,
  ffxApi,
  userAccount,
  userAccountApi,
  attend,
  attendApi,
  ai,
  aiApi,
  fixAiTestApi,
  telemarketingApi,
}

/** 过滤上传参数
 *
 * @param {*} payload 上传参数对象
 * @param {*} arr key 数组集合，示例： ['name', 'company']
 * @param {*} isExclude 是否是排除
 */
 export function filterObjWithValidValue(obj = {}, arr = [], isExclude) {
  if (getType(obj) !== 'object') return;
  let result = {};

  // 是否有效值
  const isValidValue = (value) => ![undefined, null, ''].includes(value);

  // 如果 arr 不设置，就直接过滤掉 obj 中无效的值
  if (!(Array.isArray(arr) && arr.length > 0)) {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (isValidValue(value)) result[key] = value;
    });
    return result;
  }

  if (isExclude) {
    //如果是排除 arr
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (!arr.includes(key) && isValidValue(value)) result[key] = value;
    });
  } else {
    // 如果是选取 arr
    arr.forEach((item) => {
      const value = obj[item];
      if (isValidValue(value)) result[item] = value;
    });
  }

  return result;
}
